export { Switch as default } from 'react-router-dom';



// WEBPACK FOOTER //
// /src/components/Switch.js